import React, { Fragment, useEffect, useState, useContext } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import { Alert, ButtonToolbar } from "reactstrap";
import { ContactContext, EntitySelectorContext } from "../../ContextProvider";
import EntityContext from "../../../Entities/ContextProvider";

const EntitiesSelector = ({ register, setValue }) => {
  //context

  const { item: contactData, setActiveButton } = useContext(ContactContext);
  const { tableData, currentPage, fetchTableData, rowsPerPage } =
    useContext(EntityContext);
  const {
    setContactEntities,
    contactEntities,
    getContactEntities,
    apiErrors,
    setApiErrors,
  } = useContext(EntitySelectorContext);

  const handleInputChange = (input, e) => {
    setActiveButton(true);
    setValue("entities", input);
    setContactEntities(input);
  };

  //alert
  const [alertOpen, setAlertOpen] = useState(
    apiErrors && apiErrors.length > 0 ? true : false
  );

  const ToggleAlert = () => setAlertOpen(!alertOpen);

  //usefect
  useEffect(() => {
    setAlertOpen(apiErrors && apiErrors.length > 0 ? true : false);
  }, [apiErrors]);

  useEffect(() => {
    fetchTableData(currentPage, rowsPerPage);
  }, [currentPage]);

  useEffect(() => {
    return () => {
      setApiErrors([]);
      setContactEntities([]);
    };
  }, []);

  useEffect(() => {
    if (contactData?.id) getContactEntities(contactData?.id);
  }, [contactData?.id]);

  return (
    <Fragment>
      <Alert
        className="alert-dismissible"
        color="danger inverse"
        isOpen={alertOpen}
        toggle={ToggleAlert}
      >
        <i class="icon-alert"></i>
        {apiErrors && apiErrors.length > 0 ? apiErrors[0] : ""}
      </Alert>

      <input
        type="hidden"
        name="entities"
        {...register("entities", {})}
      ></input>

      <Typeahead
        id="public-typeahead"
        selected={contactEntities}
        labelKey="name"
        multiple
        options={tableData}
        placeholder="Choose a state..."
        onChange={handleInputChange}
      />
    </Fragment>
  );
};

export default EntitiesSelector;
